import * as Styled from './styled'
import { CURRENT_LANGUAGE } from 'consts'

const langStr = CURRENT_LANGUAGE === 'en' ? '' : CURRENT_LANGUAGE

const getProjectLink = (projectId: number, isTemplate: boolean): string => {
  return `${window.location.origin}${
    langStr && `/${langStr}`
  }/${isTemplate ? 'project' : 'v-editor'}/${projectId}`
}

interface IProps {
  templateProjectIds: number[]
  videoProjectIds: number[]
}

export const ProjectIds: React.FC<IProps> = props => {
  const { templateProjectIds, videoProjectIds } = props

  return (
    <Styled.ProjectIdsWrapper>
      {templateProjectIds?.map(id => (
        <Styled.ProjectIdBox
          target="_blank"
          href={getProjectLink(id, true)}
          key={`template-${id}`}
        >
          <Styled.ProjectId>#{id}</Styled.ProjectId>
        </Styled.ProjectIdBox>
      ))}
      {videoProjectIds?.map(id => (
        <Styled.ProjectIdBox
          target="_blank"
          href={getProjectLink(id, false)}
          key={`video-${id}`}
        >
          <Styled.ProjectId>#{id}</Styled.ProjectId>
        </Styled.ProjectIdBox>
      ))}
    </Styled.ProjectIdsWrapper>
  )
}
